export async function getGiftIdeas({ recipient, customRecipient, pronoun, age, selectedInterests, anythingElse }) {
  const response = await fetch("/api/gift-ideas", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ recipient, customRecipient, pronoun, age, selectedInterests, anythingElse }),
  });

  if (!response.ok) throw new Error("API error");
  return response.json();
}
